import type { OrganizationTypeValue } from "@/types/domain";

export const TokenOperationStatus = {
  Pending: "PENDING",
  Confirmed: "CONFIRMED",
  Failed: "FAILED",
} as const;
export type TokenOperationStatusValue = (typeof TokenOperationStatus)[keyof typeof TokenOperationStatus];

export const TokenOperationType = {
  OnRamp: "ONRAMP",
  OffRamp: "OFFRAMP",
} as const;
export type TokenOperationTypeValue = (typeof TokenOperationType)[keyof typeof TokenOperationType];

export const OffRampApprovalStatus = {
  NotRequired: "NOT_REQUIRED",
  Required: "REQUIRED",
  Submitted: "SUBMITTED",
  Confirmed: "CONFIRMED",
  Failed: "FAILED",
} as const;
export type OffRampApprovalStatusValue =
  (typeof OffRampApprovalStatus)[keyof typeof OffRampApprovalStatus];

export interface TokenOperationItem {
  id: string;
  externalEntityId: string;
  externalEntityType: OrganizationTypeValue;
  amount: number;
  type: TokenOperationTypeValue;
  status: TokenOperationStatusValue;
  approvalStatus: OffRampApprovalStatusValue; // off ramp approval status
  approvalTxHash: string | null;
  approvalFailureReason: string | null;
  approvalError?: string | null;
  bankTransactionId: string | null;
  bankTransferDate: string | null;
  tokenTransferDate: string | null;
  reasonForFailure: string | null;
  txhash: string | null;
  createdAt: string;
  updatedAt: string;
}

export type TokenOperationFilters = {
  sort?: `${"createdAt" | "type" | "status"}:${"asc" | "desc"}`;
  type?: TokenOperationTypeValue;
  status?: TokenOperationStatusValue;
  createdAfter?: string;
  createdBefore?: string;
  /** Admin-only. Omitted for the unscoped ledger. */
  externalEntityId?: string;
};

export interface CounterpartyReference {
  id: string;
  externalEntityId: string;
  externalEntityType: OrganizationTypeValue;
  referenceNumber: string;
  createdAt: string;
  updatedAt: string;
}
